import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import { awaitWindowClaim } from './utils/awaitWindowClaim';
import { TAB_ID_KEY } from './constants/broadcastConstants';

(async () => {
  sessionStorage.removeItem(TAB_ID_KEY);
  const allowed = await awaitWindowClaim();
  if (!allowed) {
    // Already claimed by another tab, nothing to render
    return;
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>
  );
})();
